export const BRAND_NAME = 'MaxExch11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'maxexch11.com';
export const PROVIDER_ID = 'BetFair';
